function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./distsrc/ng2-pagination'));



//////////////////
// WEBPACK FOOTER
// ./~/ng2-pagination/index.js
// module id = 2058
// module chunks = 3